import { WindowLocation } from '@gatsbyjs/reach-router'
import { createContext } from 'react'

export interface LocationContextValue {
  location: WindowLocation | null
  setLocation: (location: WindowLocation) => void
}

export const LocationContext = createContext<LocationContextValue>({
  location: null,
  setLocation: () => {
    // noop
  },
})
